module.exports = __webpack_public_path__ + "static/media/sel.33dc6dfe.mp3";